// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:21
import { CrisisMessage_abstract } from './../abstract/SagaSchema/CrisisMessage_abstract';
export class CrisisMessage extends CrisisMessage_abstract {}
